import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import swal from '@sweetalert/with-react';
import io from 'socket.io-client';
import PropTypes from 'prop-types';
import { Wrapper, Container, Content } from '../../css/styles/wrapper';
import EquipmentFilterForm from './filterForm';
import EquipmentForm from './form';
import EquipmentList from './list';
import API from '../../services/api';
import Parameters from '../../services/parameters';

// Styles
class EquipmentContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      equipment: null,
      equipments: [],
      equipmentsOptions: [],
      loading: false,
      pageIndex: 0,
    };

    this.handleCreation = this.handleCreation.bind(this);
    this.getList();
  }

  componentDidMount() {
    this.registerToSocket();
    this.handleEquipmentsOptions();
    this.getList();
  }

  registerToSocket = () => {
    const socket = io(Parameters.URL_API);
    socket.on('equipment', () => this.getList());
  };

  refEquipment = React.createRef();

  getList = async value => {
    this.setState({ loading: true });
    try {
      const response = await API.get(`/equipments`, {
        params: {
          uuid: value?.equipment_uuid,
        },
      });
      this.setState({
        pageIndex: 0,
        equipments: response.data,
        loading: false,
      });
    } catch (err) {
      toast.error('Um erro aconteceu durante o carregamento!');
      this.setState({ loading: false });
    }
  };
  handleEquipmentsOptions = async () => {
    this.setState({ loading: true });
    try {
      const response = await API.get('/equipments/options');
      this.setState({ equipmentsOptions: response.data, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Erro ao listar veículos', error);
    }
  };
  handleCreation = async value => {
    const data = {
      code: value?.code?.toUpperCase(),
      plate: value?.plate?.toUpperCase() ?? '',
      model: value?.model?.toUpperCase() ?? '',
      year: value?.year,
      prefix: value?.prefix?.toUpperCase(),
      number: value?.number !== '' ? value?.number : null,
      status: value?.status !== '' ? value?.status : null,
    };

    try {
      const response = await API.post('/equipments', { ...data });

      this.getList(response.data);
      this.handleEquipmentsOptions();
      this.handleNew();
      toast.success('Veículo criado com sucesso!');
    } catch (err) {
      toast.error('Um erro aconteceu durante o cadastro!');
    }
  };

  handleEdit = object => {
    this.setState({ equipment: object });
  };

  handleNew = () => {
    this.setState({ equipment: null });
  };

  handleUpdate = async value => {
    const { equipment } = this.state;

    const data = {
      code: value?.code?.toUpperCase(),
      plate: value?.plate?.toUpperCase() ?? '',
      model: value?.model?.toUpperCase() ?? '',
      year: value?.year,
      prefix: value?.prefix?.toUpperCase(),
      number: value?.number !== '' ? value?.number : null,
      status: value?.status !== '' ? value?.status : null,
    };

    try {
      await API.put(`equipments/${equipment.uuid}`, { ...data });

      this.getList();
      this.handleNew();
      toast.success('Veículo atualizado com sucesso.');
    } catch (err) {
      toast.error('Um erro aconteceu durante a atualização!');
    }
  };

  handleOpenFilesModal = () => {
    const { equipment } = this.state;
    const { onFilesModal } = this.props;

    onFilesModal(equipment);
  };

  handleDelete = async uuid => {
    try {
      const confirmDelete = await swal({
        dangerMode: true,
        text: 'Confirma a exclusão do veículo?',
        buttons: {
          cancel: 'Não',
          confirm: 'Sim',
        },
      });

      if (confirmDelete) {
        await API.delete(`equipments/${uuid}`);
        toast.success('Veículo deletado com sucesso!');
        this.handleNew();
        this.getList();
      }
    } catch (err) {
      toast.error('Não é possível excluir veículos relacionados a serviços!');
    }
  };

  render() {
    const { equipment, equipments, loading } = this.state;

    return (
      <Wrapper>
        <Container>
          <header>
            <h1>VEÍCULOS</h1>
            <div className="buttons-container">
              <button type="button" onClick={this.handleNew}>
                NOVO
              </button>
            </div>
          </header>

          {loading ? (
            <ReactLoading type="spin" color="#011826" height={40} width={40} />
          ) : (
            <>
              <EquipmentFilterForm
                equipment={equipment}
                equipments={equipments}
                onCreation={this.handleCreation}
                onEdit={this.handleEdit}
                onUpdate={this.handleUpdate}
                onNew={this.handleNew}
                onDelete={this.handleDelete}
                onList={this.getList}
                equipmentsOptions={this.state.equipmentsOptions}
              />
              <EquipmentList
                equipments={equipments}
                loading={loading}
                onEdit={this.handleEdit}
                onDelete={this.handleDelete}
                pageIndex={this.state.pageIndex}
                setPageIndex={i => this.setState({ pageIndex: i })}
              />
              <EquipmentForm
                equipment={equipment}
                equipments={equipments}
                onCreation={this.handleCreation}
                onEdit={this.handleEdit}
                onUpdate={this.handleUpdate}
                onNew={this.handleNew}
                onDelete={this.handleDelete}
              />
            </>
          )}
        </Container>
      </Wrapper>
    );
  }
}

EquipmentContainer.propTypes = {
  equipmentForm: PropTypes.bool.isRequired,
  onEquipmentsList: PropTypes.func.isRequired,
  onEquipmentSubmit: PropTypes.func.isRequired,
};

export default EquipmentContainer;

